import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import Share from "@material-ui/icons/Share";
import ChatBubble from "@material-ui/icons/ChatBubble";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import TrendingUp from "@material-ui/icons/TrendingUp";
import Subject from "@material-ui/icons/Subject";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowForward from "@material-ui/icons/ArrowForward";
import { Link } from "gatsby";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardAvatar from "components/Card/CardAvatar.js";
import Info from "components/Typography/Info.js";
import Danger from "components/Typography/Danger.js";
import Success from "components/Typography/Success.js";
import Warning from "components/Typography/Warning.js";
import Rose from "components/Typography/Rose.js";
import Button from "components/CustomButtons/Button.js";
import Divider from '@material-ui/core/Divider';
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
//import Working from "assets/img/svg/working.svg";
import Parents from "assets/img/svg/Parents.svg";
import InfoArea from "components/InfoArea/InfoArea.js";
import TA from "assets/img/svg/website_home_howitworks_TA.svg";
import Box  from "@material-ui/core/Box";
import Layout from "views/Layout/Layout.js";
import {Helmet} from "react-helmet";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(featuresStyle);
const nestStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(3),
  },
}));

export default function SectionCards() {
  const nestclass = nestStyles();
  const [activeRotate1, setActiveRotate1] = React.useState("");
  const [activeRotate2, setActiveRotate2] = React.useState("");
  const [activeRotate3, setActiveRotate3] = React.useState("");
  const [open, setOpen] = React.useState(true);
  const classes = useStyles();
  const classe = useStyle();
  React.useEffect(() => {
    if (window) {
      window.addEventListener("resize", addStylesForRotatingCards);
    }
    addStylesForRotatingCards();
    return function cleanup() {
      if (window) {
        window.removeEventListener("resize", addStylesForRotatingCards);
      }
    };
  });
  const handleClick = () => {
    setOpen(!open);
  };
  const addStylesForRotatingCards = () => {
    var rotatingCards = document.getElementsByClassName(classes.cardRotate);
    for (let i = 0; i < rotatingCards.length; i++) {
      var rotatingCard = rotatingCards[i];
      var cardFront = rotatingCard.getElementsByClassName(classes.front)[0];
      var cardBack = rotatingCard.getElementsByClassName(classes.back)[0];
      cardFront.style.height = "unset";
      cardFront.style.width = "unset";
      cardBack.style.height = "unset";
      cardBack.style.width = "unset";
      var rotatingWrapper = rotatingCard.parentElement;
      var cardWidth = rotatingCard.parentElement.offsetWidth;
      var cardHeight = rotatingCard.children[0].children[0].offsetHeight;
      rotatingWrapper.style.height = cardHeight + "px";
      rotatingWrapper.style["margin-bottom"] = 30 + "px";
      cardFront.style.height = "unset";
      cardFront.style.width = "unset";
      cardBack.style.height = "unset";
      cardBack.style.width = "unset";
      cardFront.style.height = cardHeight + 35 + "px";
      cardFront.style.width = cardWidth + "px";
      cardBack.style.height = cardHeight + 35 + "px";
      cardBack.style.width = cardWidth + "px";
    }
  };
  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      '@type': 'Website',
      'name':'Working',
      'description':'Working model of BUSLOC',
      'url':'www.busloc.io/tagetstarted',
      'keywords':'BUSLOC, join BUSLOC',
      'og:description':'Working model of BUSLOC',
      'og:title':'Working - BUSLOC working is defined here'
      
    },
  ];
  return (
    <Layout>
       <Helmet>
     <title>Working - BUSLOC working is defined here</title>
       
       {/* JSON-Ld tags*/}
       <script type="application/ld+json">
   {JSON.stringify(schemaOrgJSONLD)}
 </script>
      </Helmet>
    <div className={classes.blog}>
        <div className={classes.container}>
          <div className={classes.sectionWhite}>
        <p className={classes.titlehead} style={{fontSize:"35px",marginTop:"30px",marginBottom:"10px",textAlign:'center'}}>
                 BUSLOC Presentation
              </p>
                <GridContainer>
                <GridItem  md={2} lg={2}></GridItem>
                <GridItem xs={12} sm={12} md={10} lg={10}>
               
                <div className="video"
      style={{
        position: "relative",
        paddingBottom: "56.25%" /* 16:9 */,
        paddingTop: 25,
        height: 0,
        textAlign:'center'
      }}>
                           <iframe
        style={{
          position: "absolute",
          top: 0,
          textAlign:'center',
          left: 0,
          width: "75%",
          height: "75%"
        }}
       
        src={`https://docs.google.com/presentation/d/e/2PACX-1vRSCOh-HeaNMZJY32unlJ1l3dvJYQmpK5Y01HyvJG49lebA7fMccv6OUGfnFD19XXK2FQHTsyBm-MDF/embed?start=true&loop=true&delayms=3000`}
        allow='autoplay'
        allowFullScreen='allowFullScreen'
        frameBorder="0"
        setPlaybackQuality="hd1080"
        
      
      />
     
     </div>
       </GridItem>
       <GridItem  md={2} lg={2}></GridItem>
       </GridContainer>
        <div style={{marginTop:-50}}>
          <h3 className={classes.title} style={{ fontSize: '35px' }}>How BUSLOC Works</h3>
       
        </div>
       
        <GridContainer>
          <GridItem sm={12} md={1}></GridItem>

          <GridItem xs={12} sm={12} md={10}>
          
          <Card blog >
                    <CardHeader image>
                    <img src={Parents} alt="..." />
                      {/* <a href="#pablo" onClick={e =>  e.preventDefault()}>
                      
                       
                      </a> */}
                      <div
                        className={classes.coloredShadow}
                        style={{
                          backgroundImage: `url(${Parents})`,
                          opacity: "1"
                        }}
                      />
                    </CardHeader>
                    <CardBody style={{paddingLeft:0,paddingRight:0}}>
                      <GridContainer>
                        <GridItem sm={12} md={1}>

                        </GridItem>
                        <GridItem sm={12} md={10}>
                          
                       
                 <div style={{backgroundColor:"#FFFFCC",color:'#3C4858'}}>   
                        <p className={classes.title} style={{ fontSize: '20px',textAlign:'left' ,marginLeft:10,color:'#3C4858',marginBottom:0 }}>GPS Signal</p>
                        <List>
        <ListItem style={{padding:0}}>
       {/*  <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
          
          <ListItemText style={{paddingLeft:10,marginTop:0}}>
          
          1. BUSLOC works with your Fleet’s existing GPS Hardware without need for additional devices.
          </ListItemText>
        </ListItem>
        <ListItem style={{padding:0}}>
       {/*  <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
          <ListItemText style={{paddingLeft:10,marginTop:0}}>
          2. BUSLOC readily integrates with existing fleet solutions, Routing software, GPS API, or infact with any GPS solution. 

          </ListItemText>
        </ListItem>
        <ListItem style={{padding:0}}>
      {/*   <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
          <ListItemText style={{paddingLeft:10,marginTop:0}}>
          3. BUSLOC requires only GPS signals for tracking.
          </ListItemText>
        </ListItem>
        </List>
        </div>     
        <div style={{backgroundColor:"#FFFFCC",color:'#3C4858'}}>
                        <p className={classes.title} style={{ fontSize: '20px',textAlign:'left' ,marginLeft:10,color:'#3C4858' ,marginBottom:0}}>Route Schedules
</p>
<List>
        <ListItem style={{padding:0}} style={{padding:0}}>
       {/*  <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
          <ListItemText style={{paddingLeft:10,marginTop:0}}>
         1.BUSLOC works according to your Fleet’s existing route schedules, and works for Fleet with or without any Routing software.

          </ListItemText>
        </ListItem>
        <ListItem button onClick={handleClick} style={{padding:0}}>
        {/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
        <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
        <ListItemText primary="2. For Fleets with existing routing software:" style={{paddingLeft:10,marginTop:0}}/>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
          {/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF"}}>
            <FiberManualRecord color="rose"/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
            BUSLOC readily integrates with the existing routing  software and ensures tracking of the school bus according to the route schedule. 
              </ListItemText>
          </ListItem>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
          {/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF"}}>
            <FiberManualRecord color="rose"/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
            BUSLOC synchronises with routing software without duplicating the efforts. 
              </ListItemText>
          </ListItem>
        </List>
      </Collapse>


      <ListItem button onClick={handleClick} style={{padding:0}}>
      {/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
        <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
        <ListItemText primary="3. For Fleets without Routing Software:" style={{paddingLeft:10,marginTop:0}}/>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
          {/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF"}}>
            <FiberManualRecord color="rose"/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
            BUSLOC takes the schedules as an import file and will daily monitor the routes accordingly (import file format will be provided by BUSLOC).
              </ListItemText>
          </ListItem>
        
        </List>
      </Collapse>

    
        </List>
        </div>
        <div style={{backgroundColor:"#FFFFCC",color:'#3C4858'}}>
        <p className={classes.title} style={{ fontSize: '20px',color:'#3C4858',textAlign:'left' ,marginLeft:10,marginBottom:0}}>Access to Parents 

</p>   

<p className={classes.description1} style={{color:'#3C4858',marginBottom:0,marginLeft:10}}>Access to parents can be in one of the two ways</p>
<List>
<ListItem button onClick={handleClick} style={{padding:0}}>
{/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
        <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
        <ListItemText primary="Option 1 (Student id based)" style={{paddingLeft:10,marginTop:0}}/>
       
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
        {/*   <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF"}}>
            <FiberManualRecord color="rose"/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
            BUSLOC will import students data from routing software or its equivalant csv files.
              </ListItemText>
          </ListItem>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
         {/*  <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF",fontWeight:'10px'}}>
            <FiberManualRecord color="rose" style={{color:"#FFFFFF",fontWeight:'10px'}}/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
           Student id will be used by their parents to add them in to their BUSLOC accounts, after this parents can start tracking and recieve notifications. 
              </ListItemText>
          </ListItem>
        
        </List>
      </Collapse>
    
      
   </List>

<List>
<ListItem button onClick={handleClick} style={{padding:0}}>
{/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
        <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
        <ListItemText primary="Option 2 (School Districts data)" style={{paddingLeft:10,marginTop:0}}/>
       
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
        {/*   <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF"}}>
            <FiberManualRecord color="rose"/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
            BUSLOC can sync with your school Database or can import Parents and Students data with the Students’ assigned routestops.
              </ListItemText>
          </ListItem>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
         {/*  <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF",fontWeight:'10px'}}>
            <FiberManualRecord color="rose" style={{color:"#FFFFFF",fontWeight:'10px'}}/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
            Relevant permissions are given in the MobileApp to Parents to access their kids’ routes and track the routes on the map
              </ListItemText>
          </ListItem>
        
        </List>
      </Collapse>
    
      
   </List>

   <List>
<ListItem button onClick={handleClick} style={{padding:0}}>
{/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
        <ListItemIcon style={{color:"#FFFFFF",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          </Box> */}
        <ListItemText primary="Option 3 (RouteKey® based)" style={{paddingLeft:10,marginTop:0}}/>
       
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem button className={nestclass.nested} style={{paddingBottom:0,paddingTop:0}}>
          {/* <Box display={{ xs: 'none',sm:'none', md: 'block' }}>
          <ListItemIcon style={{color:"#FFFFFF"}}>
            <FiberManualRecord color="rose"/>
          </ListItemIcon>
          </Box> */}
            <ListItemText>
            BUSLOC generates a single RouteKey® for sharing with the parents on the route; using the RouteKey®, Parents can add the route and start tracking their student’s routes. RouteKey® option does not require students or parents data integration
              </ListItemText>
          </ListItem>
      
        
        </List>
      </Collapse>
    
      
   </List>
         </div> 
         </GridItem>
                      </GridContainer>
        </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <br />
        <GridContainer>
              <GridItem xs={12} sm={12} md={2}></GridItem>
              <GridItem xs={12} sm={12} md={8}>
              <div class="box a" data-aos="fade-up"  data-aos-offset="200"
    data-aos-delay="50"
    data-aos-duration="2000">
              <h4 className={classes.cardTitle} style={{textAlign:'left'}}>
              School District Staff
                      {/*   <a href="#pablo" onClick={e => e.preventDefault()}>
                       
                        </a> */}
                      </h4>
                   
              <List className={classes.description}>
        <ListItem>
          <ListItemIcon style={{color:"#e91e63",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          <ListItemText>
          Signup with BUSLOC <a href="https://cp.busloc.io/auth/signup" style={{color:"#e91e63"}}>https://cp.busloc.io/auth/signup</a> and complete the School District/School registration
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon style={{color:"#e91e63",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          <ListItemText>
          BUSLOC will process the request and provides Dashboard access with demo data within 24 hrs. 
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon style={{color:"#e91e63",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          <ListItemText>
          BUSLOC will followup with one-on-one online meeting, data collection etc.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon style={{color:"#e91e63",fontWeight:500}}>
            <ArrowForward color="rose"/>
          </ListItemIcon>
          <ListItemText>
          BUSLOC will also send instructions on populating the data on schools, routes, routestops, and GPS hardware.
          </ListItemText>
        </ListItem>
        </List>
        <div>
        <Button round color="rose" style={{fontWeight:700}} href="https://cp.busloc.io/auth/signup">
                        <Subject /> Get Started
                        </Button>
                        
                        </div>
                        </div>
              </GridItem>
            </GridContainer>
        {/*   <GridContainer>
                
                <GridItem xs={12} sm={6} md={6}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                        <img src={Parents} alt="..." />
                      </a>
                 
                </GridItem>
                
                 <GridItem xs={12} sm={6} md={6}>
                 <a href="#pablo" onClick={e => e.preventDefault()}>
                         <img src={TA} alt="..." />
                       </a>
                  
                 </GridItem>
              </GridContainer> */}
       {/*  <GridContainer>


          <GridItem xs={12} sm={6} md={6}>

            <Card blog>
              <CardHeader color="info">
                <h3 style={{ fontWeight: 500 }}>School District Staff Workflow</h3>
              </CardHeader>
              <CardBody style={{ paddingRight: '10px', paddingLeft: '10px' }}>
                <ul className={classes.description}>
                  <li> Open a single Administrative account in BUSLOC</li>
                  <br />
                  <li>	Access the Dashboard to add schools, routes, and route stops</li> <br />
                  <li>	Distribute the auto-generated RouteKey® to Parents/Students </li> <br />
                  <li>Alternatively, add Parents’ mobile numbers for access</li><br />
                  <li>Send messages from the Dashboard</li>


                </ul>



                <Button round color="rose" component={Link} to="/takeatour/#ta" style={{ fontWeight: 700 }} >
                  <Subject /> Learn more...
                       </Button>
              </CardBody>

            </Card>

          </GridItem>
          <GridItem xs={12} sm={6} md={6}>

            <Card blog>
              <CardHeader color="info">
                <h3 style={{ fontWeight: 500 }}>Parents/Students Workflow</h3>
              </CardHeader>
              <CardBody style={{ paddingRight: '10px', paddingLeft: '10px' }}>
                <ul className={classes.description}>
                  <li> Download BUSLOC Parents App</li> <br />
                  <li>Receive notification from Staff on route access</li> <br />
                  <li>Access route either with the RouteKey® or mobile phone</li> <br />
                  <li>Setup location based alerts (as many as you wish)</li><br />
                  <li>Receive messages and alerts and/or monitor bus on the map</li>


                </ul>



                <Button round color="rose" component={Link} to="/takeatour/#parent" style={{ fontWeight: 700 }} href="https://cp.busloc.io/auth/signup">
                  <Subject /> Learn more...
                       </Button>
              </CardBody>

            </Card>

          </GridItem>


        </GridContainer> */}

      </div>
</div>

    </div>

</Layout>
  );
}
